import { Controller } from "stimulus"

// Show/hide only; copy and initial state live in shared/_portal_unavailable_modal.
// The sign-up page (fetch) opens it through the portal:unavailable event.
export default class extends Controller {
  open() {
    this.element.classList.remove("hidden")
  }

  close() {
    this.element.classList.add("hidden")
  }

  // Stimulus 2 has no key filter in data-action, so the key is checked here.
  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }
}
